// ===== CONSTANTS =====

// Polygon types
export const POLYGON_TYPES = {
  TURF: 'turf',
  ORNAMENTAL: 'ornamental',
  BARE_GROUND: 'bare_ground'
};

// Area types (includes additional types for spray/service control)
export const AREA_TYPES = {
  ORNAMENTAL: 'ornamental',
  TURF: 'turf',
  BARE_GROUND: 'bare_ground',
  DO_NOT_SPRAY: 'do_not_spray',
  DO_NOT_SERVICE: 'do_not_service'
};

// Area type display labels
export const AREA_TYPE_LABELS = {
  [AREA_TYPES.ORNAMENTAL]: 'Ornamental',
  [AREA_TYPES.TURF]: 'Turf',
  [AREA_TYPES.BARE_GROUND]: 'Bare Ground',
  [AREA_TYPES.DO_NOT_SPRAY]: 'DO NOT SPRAY',
  [AREA_TYPES.DO_NOT_SERVICE]: 'DO NOT SERVICE'
};

// Default colors for polygon types
export const DEFAULT_COLORS = {
  [POLYGON_TYPES.TURF]: '#00FF00', // Green
  [POLYGON_TYPES.ORNAMENTAL]: '#FFFF00', // Yellow
  [POLYGON_TYPES.BARE_GROUND]: '#FFA500' // Orange
};

// Default colors for area types
export const AREA_TYPE_COLORS = {
  [AREA_TYPES.ORNAMENTAL]: '#FFFF00', // Yellow
  [AREA_TYPES.TURF]: '#00FF00', // Green  
  [AREA_TYPES.BARE_GROUND]: '#FFA500', // Orange
  [AREA_TYPES.DO_NOT_SPRAY]: '#FF0000', // Red
  [AREA_TYPES.DO_NOT_SERVICE]: '#800080' // Purple
};

// Drawing modes
export const DRAWING_MODES = {
  POLYGON: 'polygon',
  FREEHAND: 'freehand',
  RECTANGLE: 'rectangle',
  CIRCLE: 'circle'
};

// Default center coordinates
export const defaultCenter = {
  lat: 33.91023013848473,
  lng: -112.084847523098
};

// Map container style
export const containerStyle = {
  width: '100%',
  height: '100%'
};

// Map libraries
export const mapLibraries = ['drawing', 'geometry'];

